import * as L from 'leaflet';
import { uniq } from 'lodash';
import DOMPurify from 'dompurify';
import { TemplateStopType } from 'services/enums/TemplateStopType';

export const planedIconColor = '#0767DB';
export const notPlanedIconColor = '#a6a6a6';
export const inDeliveryIconColor = '#DBDB00';
export const deliveredIconColor = '#00E600';
export const canNotDeliverIconColor = '#ff4646';
export const redeliveryIconColor = '#ffa900';
export const customerIconColor = '#ffffff';
export const unassignedTemplateStopIconColor = '#ffffff';
export const templateStopPickupIconColor = '#00E600';
export const templateStopDeliveryIconColor = '#ff4646';
export const templateStopConnectionColor = '#000000';

export class IconService {
  static getStopSvgTemplate(
    color,
    stopNumber,
    title = 'Marker',
    innerColor = '#ffffff'
  ) {
    const col = parseInt(color.substring(1), 16);
    const darkerColorHex = (col & 0xfefefe) >> 1;
    const darkerColor = `#${darkerColorHex.toString(16)}`;

    let textX = 9.99293;
    let circleRadius = 3.5;
    if (stopNumber.toString().length > 0) {
      circleRadius = 5;
    }
    if (stopNumber.toString().length > 1) {
      textX = 6.99293;
    }

    return DOMPurify.sanitize(`<svg width="25" height="41.00000000000001" xmlns="http://www.w3.org/2000/svg">
   <g>
      <title>${title}</title>
      <g transform="matrix(1.473906276860094,0,0,1.3917062763174055,-188.15489375044095,-67.46723861305563) " id="svg_2">
         <path d="m130.232118,51.586914c-1.25816,1.34277 -2.04623,3.29881 -2.01563,5.13867c0.0639,3.84476 1.79693,5.3002 4.56836,10.59179c0.99832,2.32851 2.04027,4.79237 3.03125,8.87305c0.13772,0.60193 0.27203,1.16104 0.33416,1.20948c0.0621,0.0485 0.19644,-0.51262 0.33416,-1.11455c0.99098,-4.08068 2.03293,-6.54258 3.03125,-8.87109c2.77143,-5.29159 4.50444,-6.74704 4.56836,-10.5918c0.0306,-1.83986 -0.75942,-3.79785 -2.01758,-5.14062c-1.43724,-1.53389 -3.60504,-2.66908 -5.91619,-2.71655c-2.31115,-0.0475 -4.4809,1.08773 -5.91814,2.62162z" stroke-miterlimit="4" stroke="${darkerColor}" fill="${color}" id="svg_3"/>
         <circle r="${circleRadius}" cy="56.868504" cx="136.150268" stroke-width="0" fill="${innerColor}" id="svg_4"/>
      </g>
      <text fill="#000000" stroke-width="1" x="${textX}" y="13.92401" id="svg_5" font-size="9" font-family="Helvetica, Arial, sans-serif" xml:space="preserve" transform="matrix(1.07302725315094,0,0,1.0934563875198364,-0.9698932059109211,-0.5475960206240416) " stroke="#000">${stopNumber}</text>
   </g>
</svg>`);
  }

  static getMicroHubSvgTemplate(color) {
    return DOMPurify.sanitize(`
    <svg width="40" height="52" viewBox="0 0 22 27" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g>
    <g>
      <mask id="path-2-inside-1" fill="white">
        <path
          d="M10.2249 18.7714C9.8661 18.7535 9.507 18.7999 9.16425 18.9083C8.15989 19.1812 7.1536 19.2193 6.18126 18.7773C4.30452 17.9245 3.92898 15.9079 5.36904 14.4252C5.65046 14.1319 5.9639 13.8766 6.26763 13.6096C6.86583 13.0856 7.38843 12.4799 7.82026 11.8101C9.18463 9.69082 12.1637 9.84828 13.2797 12.1035C13.662 12.8771 14.153 13.5372 14.8537 14.0468C15.2036 14.3096 15.5018 14.636 15.7328 15.0091C16.8546 16.7499 16.0744 18.6932 14.0618 19.1548C13.2393 19.3513 12.378 19.3041 11.5815 19.0188C11.1371 18.8604 10.6926 18.7157 10.2249 18.7714Z"/>
      </mask>
      <path
        d="M10.2249 18.7714C9.8661 18.7535 9.507 18.7999 9.16425 18.9083C8.15989 19.1812 7.1536 19.2193 6.18126 18.7773C4.30452 17.9245 3.92898 15.9079 5.36904 14.4252C5.65046 14.1319 5.9639 13.8766 6.26763 13.6096C6.86583 13.0856 7.38843 12.4799 7.82026 11.8101C9.18463 9.69082 12.1637 9.84828 13.2797 12.1035C13.662 12.8771 14.153 13.5372 14.8537 14.0468C15.2036 14.3096 15.5018 14.636 15.7328 15.0091C16.8546 16.7499 16.0744 18.6932 14.0618 19.1548C13.2393 19.3513 12.378 19.3041 11.5815 19.0188C11.1371 18.8604 10.6926 18.7157 10.2249 18.7714Z"
        fill="${color}" stroke="black" mask="url(#path-2-inside-1)"/>
      <mask id="path-3-inside-2" fill="white">
        <path
          d="M18.9987 11.1417C18.9628 12.4004 18.4058 13.3539 17.2986 13.9427C16.303 14.4718 15.2501 13.9974 14.9163 12.9089C14.7321 12.3121 14.7644 11.6688 15.0075 11.0938C15.3627 10.2136 15.8275 9.40091 16.532 8.74664C17.221 8.10802 17.9352 8.19212 18.4214 8.997C18.8163 9.65127 18.9745 10.376 18.9987 11.1417Z"/>
      </mask>
      <path
        d="M18.9987 11.1417C18.9628 12.4004 18.4058 13.3539 17.2986 13.9427C16.303 14.4718 15.2501 13.9974 14.9163 12.9089C14.7321 12.3121 14.7644 11.6688 15.0075 11.0938C15.3627 10.2136 15.8275 9.40091 16.532 8.74664C17.221 8.10802 17.9352 8.19212 18.4214 8.997C18.8163 9.65127 18.9745 10.376 18.9987 11.1417Z"
        fill="${color}" stroke="black" mask="url(#path-3-inside-2)"/>
      <mask id="path-4-inside-3" fill="white">
        <path
          d="M11.3335 6.85795C11.4228 5.95722 11.4402 4.97533 11.8527 4.06874C12.2408 3.20909 12.8444 3.02327 13.6508 3.50151C15.3626 4.51763 16.2155 6.71125 15.5625 8.39142C15.3727 8.87995 15.0556 9.30773 14.6445 9.62955C13.8216 10.2887 12.695 10.0872 12.0147 9.1699C11.5227 8.50487 11.3393 7.74204 11.3335 6.85795Z"/>
      </mask>
      <path
        d="M11.3335 6.85795C11.4228 5.95722 11.4402 4.97533 11.8527 4.06874C12.2408 3.20909 12.8444 3.02327 13.6508 3.50151C15.3626 4.51763 16.2155 6.71125 15.5625 8.39142C15.3727 8.87995 15.0556 9.30773 14.6445 9.62955C13.8216 10.2887 12.695 10.0872 12.0147 9.1699C11.5227 8.50487 11.3393 7.74204 11.3335 6.85795Z"
        fill="${color}" stroke="black" mask="url(#path-4-inside-3)"/>
      <mask id="path-5-inside-4" fill="white">
        <path
          d="M9.974 6.51666C10.0224 7.25361 9.85359 7.98854 9.4888 8.6291C9.08706 9.32347 8.54169 9.81833 7.68484 9.82322C6.82798 9.82811 6.28262 9.29805 5.9032 8.60368C5.15793 7.24134 5.43838 5.66972 6.62614 4.34945C7.02885 3.90153 7.46941 3.50153 8.03224 3.25899C8.7416 2.95386 9.24911 3.13381 9.56643 3.85361C9.92451 4.65555 9.97788 5.51423 9.974 6.51666Z"/>
      </mask>
      <path
        d="M9.974 6.51666C10.0224 7.25361 9.85359 7.98854 9.4888 8.6291C9.08706 9.32347 8.54169 9.81833 7.68484 9.82322C6.82798 9.82811 6.28262 9.29805 5.9032 8.60368C5.15793 7.24134 5.43838 5.66972 6.62614 4.34945C7.02885 3.90153 7.46941 3.50153 8.03224 3.25899C8.7416 2.95386 9.24911 3.13381 9.56643 3.85361C9.92451 4.65555 9.97788 5.51423 9.974 6.51666Z"
        fill="${color}" stroke="black" mask="url(#path-5-inside-4)"/>
      <mask id="path-6-inside-5" fill="white">
        <path
          d="M6.21575 11.7244C6.22504 12.0215 6.17896 12.3177 6.0799 12.5977C5.65584 13.8007 4.43023 14.1576 3.37444 13.3889C1.83346 12.2691 1.66267 9.5699 3.05421 8.24767C3.49962 7.82322 3.98773 7.75867 4.43702 8.16943C5.46355 9.07819 6.10102 10.3523 6.21575 11.7244Z"/>
      </mask>
      <path
        d="M6.21575 11.7244C6.22504 12.0215 6.17896 12.3177 6.0799 12.5977C5.65584 13.8007 4.43023 14.1576 3.37444 13.3889C1.83346 12.2691 1.66267 9.5699 3.05421 8.24767C3.49962 7.82322 3.98773 7.75867 4.43702 8.16943C5.46355 9.07819 6.10102 10.3523 6.21575 11.7244Z"
        fill="${color}" stroke="black" mask="url(#path-6-inside-5)"/>
    </g>
  </g>
</svg>`);
  }

  static getMarkerClusterSvgTemplate(color, text) {
    return DOMPurify.sanitize(
      text && text !== ''
        ? `<svg
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="50">
    <circle r="18" cx="25" cy="25" fill="${color}" fill-opacity="0.6" id="svg_6"/>
    <circle r="14" cx="25" cy="25" fill="${color}" fill-opacity="0.8" id="svg_7"/>
    <circle r="10" cx="25" cy="25" stroke-width="1" stroke="#000000" fill="${color}" fill-opacity="1" id="svg_8"/>
    <circle r="8" cx="25" cy="25" stroke-width="1" fill="#ffffff" fill-opacity="1" id="svg_8"/>
    <text text-anchor="middle" id="svg_5" font-size="11" font-family="Helvetica, Arial, sans-serif" font-weight="bold">
    <tspan y="28" x="25">${text}</tspan>
    </text>
    </svg>`
        : `<svg
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="50">
    <circle r="18" cx="25" cy="25" fill="${color}" fill-opacity="0.6" id="svg_6"/>
    <circle r="14" cx="25" cy="25" fill="${color}" fill-opacity="0.8" id="svg_7"/>
    <circle r="10" cx="25" cy="25" stroke-width="1" stroke="#000000" fill="${color}" fill-opacity="1" id="svg_8"/>
    </svg>`
    );
  }

  static getOverlapMarkerSvgTemplate(colors = [], numOverlaps) {
    const verticalTranslate = 25 / colors.length;
    const markerInner = colors
      .map(
        (color, index) =>
          `<path
        transform="translate(0 ${verticalTranslate * index})"
        d="m130.232118,51.586914c-1.25816,1.34277 -2.04623,3.29881 -2.01563,5.13867c0.0639,3.84476 1.79693,5.3002 4.56836,10.59179c0.99832,2.32851 2.04027,4.79237 3.03125,8.87305c0.13772,0.60193 0.27203,1.16104 0.33416,1.20948c0.0621,0.0485 0.19644,-0.51262 0.33416,-1.11455c0.99098,-4.08068 2.03293,-6.54258 3.03125,-8.87109c2.77143,-5.29159 4.50444,-6.74704 4.56836,-10.5918c0.0306,-1.83986 -0.75942,-3.79785 -2.01758,-5.14062c-1.43724,-1.53389 -3.60504,-2.66908 -5.91619,-2.71655c-2.31115,-0.0475 -4.4809,1.08773 -5.91814,2.62162z"
        fill="${color}"/>`
      )
      .join('');

    return DOMPurify.sanitize(`<svg width="25" height="41.00000000000001" xmlns="http://www.w3.org/2000/svg">
       <g>
          <title>${'Überlappungen ' + numOverlaps}</title>
          <g transform="matrix(1.473906276860094,0,0,1.3917062763174055,-188.15489375044095,-67.46723861305563) " id="svg_2">
             <mask id="markerOutline" fill="white">
                <path
                  d="m130.232118,51.586914c-1.25816,1.34277 -2.04623,3.29881 -2.01563,5.13867c0.0639,3.84476 1.79693,5.3002 4.56836,10.59179c0.99832,2.32851 2.04027,4.79237 3.03125,8.87305c0.13772,0.60193 0.27203,1.16104 0.33416,1.20948c0.0621,0.0485 0.19644,-0.51262 0.33416,-1.11455c0.99098,-4.08068 2.03293,-6.54258 3.03125,-8.87109c2.77143,-5.29159 4.50444,-6.74704 4.56836,-10.5918c0.0306,-1.83986 -0.75942,-3.79785 -2.01758,-5.14062c-1.43724,-1.53389 -3.60504,-2.66908 -5.91619,-2.71655c-2.31115,-0.0475 -4.4809,1.08773 -5.91814,2.62162z"/>
             </mask>
             <g mask="url(#markerOutline)">
                ${markerInner}
             </g>
             <path
               d="m130.232118,51.586914c-1.25816,1.34277 -2.04623,3.29881 -2.01563,5.13867c0.0639,3.84476 1.79693,5.3002 4.56836,10.59179c0.99832,2.32851 2.04027,4.79237 3.03125,8.87305c0.13772,0.60193 0.27203,1.16104 0.33416,1.20948c0.0621,0.0485 0.19644,-0.51262 0.33416,-1.11455c0.99098,-4.08068 2.03293,-6.54258 3.03125,-8.87109c2.77143,-5.29159 4.50444,-6.74704 4.56836,-10.5918c0.0306,-1.83986 -0.75942,-3.79785 -2.01758,-5.14062c-1.43724,-1.53389 -3.60504,-2.66908 -5.91619,-2.71655c-2.31115,-0.0475 -4.4809,1.08773 -5.91814,2.62162z"
               fill-opacity="0"
               stroke="#000"
               stroke-width="0.4"
             />
             <circle r="5" cy="56.868504" cx="136.150268" stroke-width="0" fill="#fff" id="svg_4"/>
          </g>
          <text fill="#000000" stroke-width="1" x="7.8" y="17.5" id="svg_5" font-size="18" font-family="Helvetica, Arial, sans-serif" xml:space="preserve"
                transform="matrix(1.07302725315094,0,0,1.0934563875198364,-0.9698932059109211,-0.5475960206240416) " stroke="#000">+</text>
       </g>
    </svg>`);
  }

  static getChestMarkerSvgTemplate(
    color,
    title = 'Marker',
    innerColor = '#ffffff',
    strokeWidth = 1
  ) {
    return DOMPurify.sanitize(`
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.22 41.52" width="25" height="41.00000000000001">
      <title>${title}</title>
      <g id="Truhe">
        <path fill="${color}" d="M2.65,18V6.93c0-.13-.07-.24-.17-.32-.22-.16-.41-.36-.56-.6-.18-.29-.28-.63-.28-1.01v-3c0-.55.2-1.02.59-1.41s.86-.59,1.41-.59h16c.55,0,1.02.2,1.41.59s.59.86.59,1.41v3c0,.38-.09.72-.28,1.01-.15.23-.33.43-.56.6-.1.08-.17.19-.17.32v11.07M2.65,7.33v10.27s.01.09.03.13c.07.15.26.26.48.26h16.98c.28,0,.51-.18.51-.4V7.33c0-.22-.23-.4-.51-.4H3.15c-.28,0-.51.18-.51.4ZM4.04,5h15.21c.22,0,.4-.18.4-.4v-2.21c0-.22-.18-.4-.4-.4H4.04c-.22,0-.4.18-.4.4v2.21c0,.22.18.4.4.4Z"/>
        <rect fill="${color}" x="3.28" y="1.55" width="16.72" height="3.84"/>
      </g>
      <g id="Pin_Truhe" data-name="Pin Truhe">
        <path fill="${color}" d="M3,5.59C1.15,7.46-.01,10.18.03,12.74c.09,5.35,2.65,7.38,6.73,14.74,1.47,3.24,3.01,6.67,4.47,12.35.2.84.4,1.62.49,1.68.09.07.29-.71.49-1.55,1.46-5.68,3-9.11,4.47-12.35,4.08-7.36,6.64-9.39,6.73-14.74.05-2.56-1.12-5.29-2.97-7.15-2.12-2.13-5.31-3.71-8.72-3.78-3.41-.07-6.6,1.51-8.72,3.65h0Z"/>
        <ellipse fill="${innerColor}" cx="11.73" cy="13.37" rx="7.89" ry="7.45"/>
        <path fill="${color}" d="M11.73,1.94c-1.7-.07-4.04.55-4.98,1.06s-2.03,1-3.35,2.2c-.63.77-1.26,1.12-1.89,2.32S.43,9.77.17,11.07s-.13,1.67-.13,1.67h3.62l19.77.13-.15-1.78s-1.13-3.23-1.87-4.27-2.16-2.23-2.91-2.72-2.11-1.25-3.18-1.55-1.88-.56-3.58-.62Z"/>
        <ellipse fill="${innerColor}" cx="11.73" cy="5.64" rx="1.45" ry="1.5"/>
        <rect fill="${innerColor}" x="11.12" y="6.36" width="1.2" height="2.23" rx=".52" ry=".52"/>
      </g>
       <path fill="none" stroke="#000000" stroke-width="${strokeWidth}" d="M 3.640625 0 C 3.090625 7.4014868e-17 2.6204688 0.19984375 2.2304688 0.58984375 C 1.8404688 0.97984375 1.640625 1.45 1.640625 2 L 1.640625 5 C 1.640625 5.38 1.7399219 5.7197656 1.9199219 6.0097656 C 2.0159519 6.1634136 2.1296648 6.2990624 2.2558594 6.4199219 C 2.0072573 6.7067716 1.7583677 7.0460035 1.5097656 7.5195312 C 0.81160733 8.6816458 0.32930374 9.9809351 0.13085938 11.289062 C -0.039197706 12.232725 0.0081007012 12.601274 0.029296875 12.695312 C 0.029448461 12.710218 0.029064143 12.725339 0.029296875 12.740234 C 0.11929688 18.090234 2.6797656 20.120469 6.7597656 27.480469 C 8.2297656 30.720469 9.7704688 34.150078 11.230469 39.830078 C 11.430469 40.670078 11.630703 41.449766 11.720703 41.509766 C 11.810703 41.579766 12.010938 40.800938 12.210938 39.960938 C 13.670938 34.280938 15.209688 30.849375 16.679688 27.609375 C 20.759687 20.249375 23.320156 18.219141 23.410156 12.869141 L 23.429688 12.869141 L 23.40625 12.599609 C 23.400669 12.188346 23.367587 11.773215 23.302734 11.359375 L 23.279297 11.089844 C 23.279297 11.089844 23.239736 10.979311 23.230469 10.953125 C 22.961361 9.6196424 22.401759 8.3112695 21.626953 7.1679688 C 21.552503 7.037509 21.47907 6.917164 21.410156 6.8203125 C 21.307119 6.6755036 21.18826 6.5272369 21.0625 6.3789062 C 21.173714 6.2656047 21.272295 6.1432883 21.359375 6.0097656 C 21.549375 5.7197656 21.640625 5.38 21.640625 5 L 21.640625 2 C 21.640625 1.45 21.440781 0.97984375 21.050781 0.58984375 C 20.660781 0.19984375 20.190625 0 19.640625 0 L 3.640625 0 z " />
    </svg>`);
  }

  static getShopMarkerSvgTemplate(
    color,
    title = 'Marker',
    innerColor = '#ffffff',
    strokeWidth = '1'
  ) {
    return DOMPurify.sanitize(`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.22 39.58" width="25" height="41.00000000000001">
        <title>${title}</title>
        <g id="Dach">
          <g>
            <path fill="${color}" d="M3,3.65C1.15,5.52-.01,8.24.03,10.81c.09,5.35,2.65,7.38,6.73,14.74,1.47,3.24,3.01,6.67,4.47,12.35.2.84.4,1.62.49,1.68.09.07.29-.71.49-1.55,1.46-5.68,3-9.11,4.47-12.35,4.08-7.36,6.64-9.39,6.73-14.74.05-2.56-1.12-5.29-2.97-7.15C18.33,1.65,15.13.07,11.73,0,8.32-.06,5.12,1.52,3,3.65Z"/>
            <ellipse fill="${innerColor}" cx="11.73" cy="11.43" rx="7.89" ry="7.45"/>
          </g>
          <path fill="${color}" d="M11.73,0c-1.7-.07-4.04.55-4.98,1.06s-2.03,1-3.35,2.2c-.63.77-1.26,1.12-1.89,2.32S.43,7.83.17,9.14s-.13,1.67-.13,1.67h3.62l19.77.13-.15-1.78s-1.13-3.23-1.87-4.27-2.16-2.23-2.91-2.72-2.11-1.25-3.18-1.55S13.42.07,11.73,0Z"/>
          <g>
            <rect fill="${innerColor}" x="3.28" y="2.42" width="17.11" height="5.78"/>
            <path fill="${color}" d="M2.73,9.02c-.38-.35-.68-.8-.89-1.35-.21-.55-.21-1.15-.01-1.8l1.05-3.4c.13-.43.37-.79.71-1.08.34-.28.74-.42,1.19-.42h13.9c.45,0,.84.14,1.17.41.33.28.58.64.73,1.09l1.05,3.4c.2.65.2,1.24-.01,1.78-.21.53-.5.99-.89,1.38M13.93,7.97c.45,0,.79-.15,1.02-.46.23-.31.32-.65.27-1.04l-.55-3.5h-1.95v3.7c0,.35.12.65.35.91.23.26.52.39.85.39ZM9.43,7.97c.38,0,.7-.13.94-.39.24-.26.36-.56.36-.91v-3.7h-1.95l-.55,3.5c-.07.4.02.75.26,1.05.24.3.55.45.94.45ZM4.98,7.97c.3,0,.56-.11.79-.32s.36-.49.41-.82l.55-3.85h-1.95l-1,3.35c-.1.33-.05.69.16,1.07.21.38.55.57,1.04.57ZM18.48,7.97c.48,0,.83-.19,1.05-.57.22-.38.27-.74.15-1.07l-1.05-3.35h-1.9l.55,3.85c.05.33.19.61.41.82.23.22.49.32.79.32ZM18.56,9.97h-.09"/>
          </g>
          <path fill="none" stroke="#000000" stroke-width="${strokeWidth}" d="M 11.404297 -0.005859375 C 11.172887 -0.0041453809 10.929893 0.015348214 10.685547 0.037109375 C 10.583893 0.045165911 10.48194 0.05167282 10.380859 0.0625 C 10.367149 0.064113072 10.353567 0.066694934 10.339844 0.068359375 C 10.143407 0.090142253 9.9478808 0.11654188 9.7539062 0.1484375 C 7.835626 0.38693252 5.5377724 0.81099403 4.6757812 0.97460938 C 4.268101 0.99473354 3.9033415 1.1324504 3.5898438 1.390625 C 3.2498438 1.680625 3.0108594 2.0407031 2.8808594 2.4707031 L 2.2617188 4.4746094 C 2.0168284 4.7564099 1.770281 5.0900563 1.5253906 5.5507812 C 1.5198892 5.5611313 1.515267 5.5695993 1.5097656 5.5800781 C 0.84977048 6.6791559 0.38654317 7.9021704 0.16992188 9.140625 C 0.15672583 9.2160687 0.14023699 9.2916579 0.12890625 9.3671875 C -0.039627865 10.311778 0.0081527482 10.673608 0.029296875 10.765625 C 0.029448176 10.780528 0.02906508 10.795654 0.029296875 10.810547 C 0.11929688 16.160547 2.6797656 18.190781 6.7597656 25.550781 C 8.2297656 28.790781 9.7704688 32.220391 11.230469 37.900391 C 11.430469 38.740391 11.630703 39.520078 11.720703 39.580078 C 11.810703 39.650078 12.010938 38.869297 12.210938 38.029297 C 13.670938 32.349297 15.209688 28.919688 16.679688 25.679688 C 20.759687 18.319688 23.320156 16.289453 23.410156 10.939453 L 23.429688 10.939453 L 23.40625 10.669922 C 23.400669 10.258659 23.367587 9.8435277 23.302734 9.4296875 L 23.279297 9.1601562 C 23.279297 9.1601562 23.239736 9.0496239 23.230469 9.0234375 C 22.961361 7.6899549 22.401759 6.381582 21.626953 5.2382812 C 21.552503 5.1078215 21.47907 4.9874765 21.410156 4.890625 C 21.369059 4.8328674 21.318498 4.773381 21.273438 4.7148438 L 20.580078 2.4707031 C 20.430078 2.0207031 20.179609 1.6608594 19.849609 1.3808594 C 19.52932 1.1188047 19.152081 0.98064494 18.71875 0.97265625 L 18.919922 0.97070312 C 18.919922 0.97070312 15.417276 0.35276352 13.046875 0.10351562 C 12.612609 0.045220922 12.173495 0.0091211302 11.730469 0 C 11.624219 -0.004375 11.515049 -0.0066796875 11.404297 -0.005859375 z " />
        </g>
      </svg>`);
  }

  static getCustomerMarkerIcon(color, title) {
    return L.divIcon({
      className: '',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [0, -38],
      html: this.getStopSvgTemplate(color, '', title, '#000000'),
    });
  }

  static getUnassignedTemplateStopMarkerIcon(
    color,
    innerColor,
    title,
    stopType,
    isSelected
  ) {
    if (stopType == null) {
      return L.divIcon({
        className: '',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [0, -38],
        html: this.getStopSvgTemplate(color, '', title, innerColor),
      });
    }
    if (stopType === TemplateStopType.Pickup) {
      return L.divIcon({
        className: '',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [0, -38],
        html: this.getShopMarkerSvgTemplate(
          color,
          title,
          innerColor,
          isSelected ? '3' : '1'
        ),
      });
    } else {
      return L.divIcon({
        className: '',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [0, -38],
        html: this.getChestMarkerSvgTemplate(
          color,
          title,
          innerColor,
          isSelected ? '3' : '1'
        ),
      });
    }
  }

  static getTemplateStopMarkerIcon(color, title) {
    return L.divIcon({
      className: '',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [0, -38],
      html: this.getStopSvgTemplate(color, '', title),
    });
  }

  static getTourStopMarkerIcon(color, stopNumber, title) {
    if (stopNumber === null) {
      stopNumber = '';
    }
    return L.divIcon({
      className: '',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [0, -38],
      html: this.getStopSvgTemplate(color, stopNumber, title),
    });
  }

  static getTemplateStopTemplateStopMarkerIcon(
    color,
    stopNumber,
    title,
    stopType,
    isSelected
  ) {
    if (stopNumber === null) {
      stopNumber = '';
    }
    if (stopType == null) {
      return L.divIcon({
        className: '',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [0, -38],
        html: this.getStopSvgTemplate(color, stopNumber, title),
      });
    } else {
      if (stopType === TemplateStopType.Pickup) {
        return L.divIcon({
          className: '',
          iconSize: [25, 41],
          iconAnchor: [12, 41],
          popupAnchor: [0, -38],
          html: this.getShopMarkerSvgTemplate(
            color,
            title,
            stopNumber,
            isSelected ? '3' : '1'
          ),
        });
      } else if (stopType === TemplateStopType.Delivery) {
        return L.divIcon({
          className: '',
          iconSize: [25, 41],
          iconAnchor: [12, 41],
          popupAnchor: [0, -38],
          html: this.getChestMarkerSvgTemplate(
            color,
            title,
            stopNumber,
            isSelected ? '3' : '1'
          ),
        });
      }
    }
  }

  static getMicroHubIcon(color) {
    return L.divIcon({
      className: '',
      iconSize: [25, 41],
      iconAnchor: [15, 31],
      popupAnchor: [0, -25],
      html: this.getMicroHubSvgTemplate(color === null ? '#000000' : color),
    });
  }

  static getMarkerClusterIcon(color, text = '') {
    return L.divIcon({
      className: '',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [0, -38],
      html: this.getMarkerClusterSvgTemplate(
        color === null ? '#000000' : color,
        text
      ),
    });
  }

  static getOverlappingMarkersIcon(colors, numElements) {
    //Sort colors and make sure to take different looking colors
    const tmpColors = uniq(colors).sort();
    let colorsForMaker = tmpColors.splice(0, 1);
    colorsForMaker = colorsForMaker.concat(
      tmpColors.splice(Math.floor(tmpColors.length / 2), 1)
    );
    colorsForMaker = colorsForMaker.concat(
      tmpColors.splice(tmpColors.length - 1, 1)
    );
    colorsForMaker = colorsForMaker.concat(tmpColors.splice(1, 1));
    colorsForMaker = colorsForMaker.concat(
      tmpColors.splice(tmpColors.length - 2, 1)
    );
    colorsForMaker = uniq(colorsForMaker);
    return L.divIcon({
      className: '',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [0, -38],
      html: this.getOverlapMarkerSvgTemplate(colorsForMaker, numElements),
    });
  }
}
